import { Link } from "react-router-dom";
import PerSiteFormatedMessage from "../../../../../app/modules/Globals/components/PerSiteFormatedMessage";
import { useFlags } from "../../../../../config/featureFlags";
import logo from "../../../../_assets/plugins/keenthemes-icons/svg/open-saiema-logo.svg";
import "./headerLogo.scss";
import {toAbsoluteUrl} from "../../../../_helpers";
import {FormattedMessage} from "react-intl";
function HeaderLogo() {
  const {DISPLAY_LIKUMI_CONTENT} = useFlags();

  return (
    <div>
      {DISPLAY_LIKUMI_CONTENT ? (
        <Link to="/">
          <img
            alt={<PerSiteFormatedMessage id="PAGE.TITLE" />}
            src={logo}
            className="header-logo"
          />
        </Link>
      ) : (
        <Link to="/" className="header-code-logo-block">
          <img
            alt={<PerSiteFormatedMessage id="PAGE.TITLE" />}
            src={toAbsoluteUrl("/media/logos/logo-letter-1.png")}
            className="header-logo"
          />
          <span
            className="header-code-title"
          >
            <FormattedMessage id="CODE.PAGE.TITLE" />
          </span>
        </Link>
      )}
    </div>
  );
}

export default HeaderLogo;
